import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyCPIXddNE03PCLgW8o8qb5iuVMftkdJmw0',
  authDomain: 'src-influencer.firebaseapp.com',
  projectId: 'src-influencer',
  storageBucket: 'src-influencer.appspot.com',
  messagingSenderId: '57376425003',
  appId: '1:57376425003:web:4b5328627553069ae6166e',
  measurementId: 'G-ECX45ZP00Q'
};

// Initialize Firebase only if it hasn't been initialized yet
const app =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Export Firebase services as needed
export const auth = getAuth(app);
export default app;
